import { get } from 'lodash';
import {
  DEFAULT_MATCHES_LIMIT,
  DEFAULT_MATCHES_PAGE,
  GET_SHOPIFY_MATCHES,
  GET_SHOPIFY_REMOTE_LOCATIONS,
  GET_SHOPIFY_REMOTE_LOCATIONS_ERROR,
  GET_SHOPIFY_SETTINGS,
  GET_SHOPIFY_SETTINGS_ERROR,
  PRODUCT_DETAILS,
  RESET_SHOPIFY_MATCHES,
  RESET_SHOPIFY_SELECTED_ITEMS,
  SAVE_SHOPIFY_SETTINGS,
  SET_SHOPIFY_ALL_SELECTED,
  SET_SHOPIFY_MATCHES,
  SET_SHOPIFY_REMOTE_LOCATIONS,
  SET_SHOPIFY_SELECTED_ITEMS,
  SET_SHOPIFY_STATE,
  SHOPIFY_MATCHES,
} from '../constants';
import { fetchEcommerceSyncSettings, fetchShopifyFulfillmentLocations, getMatches } from '../actions';
import { Logger } from '../../../../../modules/infra/observability/logger';
import { CONNECT, SETTINGS } from '../../../../main/settings/integrations/constants';

export const fetchMatches = (
  brandId,
  shopifySettings,
  status,
  limit = DEFAULT_MATCHES_LIMIT,
  page = DEFAULT_MATCHES_PAGE
) => async (dispatch) => {
  dispatch({
    type: GET_SHOPIFY_MATCHES,
  });

  try {
    const matchesResponse = await getMatches(
      brandId,
      shopifySettings.locationType,
      shopifySettings.locationId,
      status,
      PRODUCT_DETAILS,
      limit,
      page
    );

    dispatch({
      type: SET_SHOPIFY_MATCHES,
      payload: matchesResponse,
    });
  } catch (error) {
    Logger.error('Fetch Shopify matches', {
      error,
      action: 'Fetch Shopify matches',
    });

    dispatch({
      type: SET_SHOPIFY_MATCHES,
      payload: [],
    });
  }
};

export const setSelectedItems = items => (dispatch) => {
  dispatch({
    type: SET_SHOPIFY_SELECTED_ITEMS,
    payload: items,
  });
};

export const resetSelectedItems = () => (dispatch) => {
  dispatch({
    type: RESET_SHOPIFY_SELECTED_ITEMS,
  });
};

export const setAllSelected = (allSelected, selectedItems) => (dispatch) => {
  dispatch({
    type: SET_SHOPIFY_ALL_SELECTED,
    payload: {
      allSelected,
      selectedItems,
    },
  });
};

export const resetMatches = () => (dispatch) => {
  dispatch({
    type: RESET_SHOPIFY_MATCHES,
  });
};

export const setShopifyConnectState = () => (dispatch) => {
  dispatch({
    type: SET_SHOPIFY_STATE,
    payload: CONNECT,
  });
};

export const fetchSettings = brandId => (dispatch) => {
  dispatch({
    type: GET_SHOPIFY_SETTINGS,
  });

  return fetchEcommerceSyncSettings(brandId, 'shopify')
    .then((response) => {
      if (response.status === 'disconnected') {
        dispatch(setShopifyConnectState());

        dispatch({
          type: SAVE_SHOPIFY_SETTINGS,
          payload: response.settings || {},
        });

        return;
      }

      const newShopifyConnectionState = response.settings ? SHOPIFY_MATCHES : SETTINGS;

      dispatch({
        type: SAVE_SHOPIFY_SETTINGS,
        payload: response.settings || {},
      });

      dispatch({
        type: SET_SHOPIFY_STATE,
        payload: newShopifyConnectionState,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SHOPIFY_SETTINGS_ERROR,
      });
      Logger.error('Fetch ecommerce sync settings', {
        error,
        action: 'Fetch ecommerce sync settings',
      });
    });
};

export const fetchRemoteLocations = brandId => async (dispatch) => {
  let shopifyLocations = [];

  dispatch({
    type: GET_SHOPIFY_REMOTE_LOCATIONS,
  });

  try {
    shopifyLocations = await fetchShopifyFulfillmentLocations(brandId, 'shopify');
  } catch (error) {
    Logger.error('Fetch Shopify fulfillment locations', {
      error,
      action: 'Fetch Shopify fulfillment locations',
    });

    dispatch({
      type: GET_SHOPIFY_REMOTE_LOCATIONS_ERROR,
    });

    return;
  }

  const locationsToOptions = shopifyLocations.map(remoteLocation => ({
    label: `${remoteLocation.name} ${remoteLocation.address}`,
    value: remoteLocation.id.toString(),
  }));

  dispatch({
    type: SET_SHOPIFY_REMOTE_LOCATIONS,
    payload: {
      shopifyLocations,
      locationsToOptions,
    },
  });
};

export const initializeEcommerceMatches = (brandId, message, completedId) => (dispatch) => {
  const completed = get(message, 'ecommerceMatch.completed', '');

  if (completed === completedId) {
    dispatch(fetchSettings(brandId));
  }
};
